import React from 'react';
import Plot from 'react-plotly.js';
import { Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { PopulationOverviewData, useGetOverviewDataQuery } from '../../store/api/analysisApi';
import * as Plotly from 'plotly.js';

const PopulationOverview: React.FC = () => {
  const { data, isLoading, error } = useGetOverviewDataQuery();

  if (isLoading) return <div className="text-center p-5"><Spinner animation="border" /></div>;
  if (error || !data) return <Alert variant="danger">{'Failed to fetch population data.'}</Alert>;

  return (
    <Card>
      <Card.Body>
        <Card.Title>Global Population Metrics</Card.Title>
        <Row className="mb-4 text-center">
          <Col><Card bg="light"><Card.Body><h5>{data.metrics.totalSubjects}</h5><p>Total Subjects</p></Card.Body></Card></Col>
          <Col><Card bg="light"><Card.Body><h5>{data.metrics.totalBatches}</h5><p>Total Batches</p></Card.Body></Card></Col>
          <Col><Card bg="light"><Card.Body><h5>{data.metrics.meanZScore?.toFixed(2)}</h5><p>Mean Z-Score</p></Card.Body></Card></Col>
          <Col><Card bg="light"><Card.Body><h5>{data.metrics.stdZScore?.toFixed(2)}</h5><p>Z-Score Std. Dev.</p></Card.Body></Card></Col>
        </Row>
        <hr />
        <h4>Z-Score Distribution Across All Batches</h4>
        <Plot
          data={Object.entries(data.plots.ridgeline).map(([name, values]): Plotly.Data => ({
            type: 'violin', x: values, name: name, side: 'positive', orientation: 'h', points: false, meanline: { visible: false }
          }))}
          layout={{ title: { text: '' }, showlegend: false, height: Object.keys(data.plots.ridgeline).length * 40 + 150 }}
          style={{ width: '100%' }} useResizeHandler={true}
        />
        <hr />
        <h4>Principal Component Analysis (PCA)</h4>
        <Row className="mt-4">
          <Col md={6}>
            <Plot
              data={[{ x: data.plots.pcaScores.pc1, y: data.plots.pcaScores.pc2, type: 'scatter', mode: 'markers', text: data.plots.pcaScores.subjectIds, marker: { color: data.plots.pcaScores.groups.map(g => g === 'Male' ? '#1f77b4' : '#ff7f0e'), size: 8, opacity: 0.7 }}]}
              layout={{ title: { text: 'PCA Scores Plot (Colored by Gender)' }, xaxis: { title: { text: `PC1 (${(data.plots.pcaScores.varianceExplained[0] * 100).toFixed(1)}%)` } }, yaxis: { title: { text: `PC2 (${(data.plots.pcaScores.varianceExplained[1] * 100).toFixed(1)}%)` } }, height: 500, hovermode: 'closest' }}
              style={{ width: '100%' }} useResizeHandler={true}
            />
          </Col>
          <Col md={6}>
            <Plot
              data={data.plots.pcaLoadings.labels.map((label, i): Plotly.Data => ({ type: 'scatter', x: [0, data.plots.pcaLoadings.pc1[i]], y: [0, data.plots.pcaLoadings.pc2[i]], mode: 'lines', line: { color: '#d9534f', width: 2 }, name: label }))}
              layout={{ title: { text: 'PCA Loadings Plot' }, xaxis: { title: { text: 'PC1' }, range: [-1, 1] }, yaxis: { title: { text: 'PC2' }, range: [-1, 1], scaleanchor: 'x' }, height: 500, showlegend: true, annotations: data.plots.pcaLoadings.labels.map((label, i) => ({ x: data.plots.pcaLoadings.pc1[i] * 1.15, y: data.plots.pcaLoadings.pc2[i] * 1.15, text: label, showarrow: false}))}}
              style={{ width: '100%' }} useResizeHandler={true}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default PopulationOverview;